<template>
<div @mouseenter="isOverlay = true" @mouseleave="isOverlay = false">
  <div 
    class="card-item-overlay" 
    v-if="isOverlay && domain.description.length" 
    @click="openModal()" 
    data-toggle="modal" 
    data-target="#exampleModalCenter"
  >
    <i class="fa fa-search search-icon"></i>
    <h5>Citeste mai mult</h5>
  </div>
  <div class="icon">
    <i :class="domain.icon"></i>
  </div>
  <div class="title">
    <h5>{{ domain.title }}</h5>
  </div>

  <div class="modal fade" v-if="isModalOpened" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="exampleModalLongTitle">{{ domain.title }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-for="(domain, index) in domain.description" v-bind:key="index"> - {{ domain }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
 
</template>

<script>
export default {
  name: 'DomainCard',
  props: ['domain'],
   data: function () {
    return {
      isOverlay: false,
      isModalOpened: false,
    }
  },
  methods:{
    openModal() {
      this.isModalOpened = true;
    },
    closeModal() {
      this.isModalOpened = false;
      this.isOverlay = false
    }
  }
}
</script>

<style lang="scss">
@import "../scss/_variables.scss";
.card-item-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: $theme-color;
  color: white;
  font-size: 50px;
  text-align: center;

  &:hover {  
    cursor: pointer;
  }

  .search-icon {
    vertical-align: middle;
    margin-top: 80px;
  }
}
.modal-body {
  color: #000;
  text-align: start;
  font-weight: 500;
}
.modal-header {
  background-color: #000;

  .close {
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
}
</style>
